import { render, staticRenderFns } from "./ShopShare.vue?vue&type=template&id=ba5c06c0&scoped=true&"
import script from "./ShopShare.vue?vue&type=script&lang=js&"
export * from "./ShopShare.vue?vue&type=script&lang=js&"
import style0 from "./ShopShare.vue?vue&type=style&index=0&id=ba5c06c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba5c06c0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Administrator\\Desktop\\gtzn\\FreeGoShop\\client_web_food_market\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('ba5c06c0', component.options)
    } else {
      api.reload('ba5c06c0', component.options)
    }
    module.hot.accept("./ShopShare.vue?vue&type=template&id=ba5c06c0&scoped=true&", function () {
      api.rerender('ba5c06c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shop/ShopShare.vue"
export default component.exports